import React from "react";
import styles from "./style.module.css";

interface ButtonsWithBadgeProps {
  count?: number;
  onClick?: () => void;
}

const Index: React.FC<ButtonsWithBadgeProps> = (
  {
    count = 0,
    onClick,
  }
) => {
  return (
    <div className={`${styles.wrapper} messaging_app_wrapper`}>
      <button className={`${styles.iconButton} messaging_app_icon`} onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={styles.icon}
        >
          <path
            d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
          <path
            d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1"/>
        </svg>

        {count > 0 && (
          <span className={`${styles.badge} messaging_app_badge`}>{count}</span>
        )}
      </button>
    </div>
  );
};

export default Index;
